var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "inline-block",
        clear: "bottom",
        "margin-left": "12px",
      },
    },
    [
      _vm._t("default"),
      _c(
        "vxe-modal",
        {
          attrs: {
            type: "confirm",
            status: "warning",
            iconStatus: "vxe-icon--question",
            showFooter: true,
          },
          on: {
            confirm: function ($event) {
              return _vm.$emit("confirm")
            },
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }